import { Theme } from '../types/widget';
import MapMarker from '../components/claims-widget/assets/marker.svg';

export async function loadAutocompleteStyle(theme: Theme | undefined) {
  if (typeof window === 'undefined' || !theme) return;
  const styleElem = document.createElement('style', {
    is: 'claims-widget-map-style',
  });
  const svgContent = await (await fetch(MapMarker)).text();
  let primaryMapMarker = document.createElement('svg') as unknown as SVGElement;
  let secondaryMapMarker = document.createElement('svg') as unknown as SVGElement;
  primaryMapMarker.innerHTML = svgContent;
  secondaryMapMarker.innerHTML = svgContent;
  primaryMapMarker = primaryMapMarker.firstChild as SVGElement;
  secondaryMapMarker = secondaryMapMarker.firstChild as SVGElement;
  if (!theme.primary) return;
  if (!theme.secondary) return;
  primaryMapMarker.style.fill = theme.primary;
  secondaryMapMarker.style.fill = theme.secondary;
  styleElem.innerHTML = `
      .pac-item {
        padding: 8px 16px;
        cursor: pointer;
        background-color: #fff;
        border-radius: 2px;
        font-family: inherit;
      }


      .pac-icon {
        background-image: url("data:image/svg+xml,${encodeURIComponent(secondaryMapMarker.outerHTML)}") !important;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px;
        margin: 4px 6px 6px 0;
        vertical-align: middle;
      }

      .pac-item-selected, .pac-item:hover {
        color: ${theme.primary};
      }

      .pac-item-selected .pac-icon {
        background-image: url("data:image/svg+xml,${encodeURIComponent(primaryMapMarker.outerHTML)}") !important;;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px;
        margin: 4px 6px 6px 0;
        vertical-align: middle;
      }

      .pac-item:hover .pac-icon {
        background-image: url("data:image/svg+xml,${encodeURIComponent(primaryMapMarker.outerHTML)}") !important;;
      }

      .pac-item-selected .pac-item-query {
        color: ${theme.primary};
      }

      .pac-item:hover .pac-item-query {
        color: ${theme.primary};
      }
      `;
  document.head.append(styleElem);
}
